'use client';

import { useEffect } from 'react';
import { Button } from '@velux/components-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-secondary">
      <div className="w-full max-w-md bg-white p-8 shadow-card text-center">
        <h2 className="text-2xl font-bold text-text-primary mb-4">
          Something went wrong
        </h2>
        <p className="text-text-secondary mb-6">
          An unexpected error occurred. Please try again.
        </p>
        <Button
          variant="professional-red"
          onClick={() => reset()}
        >
          Try again
        </Button>
      </div>
    </div>
  );
}
